import { Component, ChangeDetectionStrategy, ViewEncapsulation, Input, Output, EventEmitter, ChangeDetectorRef, AfterViewChecked, OnInit, OnDestroy } from '@angular/core';
import { AppState } from '../../../../interfaces/app-state.interface';
import { Store } from '@ngrx/store';
import { MediaAction } from '../../../../state-management/media/media.action';
import { UtilitiesService } from '../../../../services/utilities.service';
import { Subscription, timer } from 'rxjs';
import { first } from 'rxjs/operators';
import { AutoUnsubscribe } from 'ngx-auto-unsubscribe';

@AutoUnsubscribe()
@Component({
    selector: `tr-playlist`,
    changeDetection: ChangeDetectionStrategy.OnPush,
    styleUrls: ['./tr-playlist.component.scss'],
    templateUrl: './tr-playlist.component.html',
    encapsulation: ViewEncapsulation.None,
})
export class TrPlaylistComponent implements AfterViewChecked, OnInit, OnDestroy {

    @Input() public mediaGroupId: string;
    @Input() public set currentVideoSlug(slug: string) {
        this.videos.map((video) => video.active = this.utilitiesService.createSlug(video.title) === slug);
    }
    @Output() public onVideoSelected: EventEmitter<any> = new EventEmitter();
    @Output() public onClose: EventEmitter<any> = new EventEmitter();

    public visible: boolean = false;
    public ready: boolean = false;
    public videos = [];
    public opens = 0;
    private videosDataSubscription: Subscription;

    constructor(
        private changeDetector: ChangeDetectorRef,
        private store: Store<AppState>,
        private utilitiesService: UtilitiesService,
    ) {
        this.videosDataSubscription = this.store.select((videosStore) => videosStore.media.videos)
            .pipe(first( (video) => this.filterVideosByGroupId(this.mediaGroupId, video).length > 0))
            .subscribe((videos) => {
                this.videos = this.filterVideosByGroupId(this.mediaGroupId, videos);
                this.checkContinuePoint();
            });
    }

    public ngOnInit() {
        if (this.mediaGroupId !== undefined) {
            this.store.dispatch({type: MediaAction.getVideosByGroupId, payload: this.mediaGroupId});
        }
    }

    public ngAfterViewChecked() {
        if (!this.ready) {
            this.ready = true;
        }
    }

    /**
     * Exibir a playlist
     */
    public show() {
        this.opens++;
        this.visible = true;
        this.changeDetector.detectChanges();
        this.changeDetector.markForCheck();
    }

    /**
     * Esconder a plylist
     */
    public close() {
        this.visible = false;
        this.changeDetector.detectChanges();
        this.changeDetector.markForCheck();
        timer(800)
            .subscribe(() => this.onClose.emit(true));
    }

    /**
     * Seleciona um video da lista
     */
    public selectVideo(video) {
        if (!video.active) this.onVideoSelected.emit(video);
    }

    public getCurrentVideo() {
        return this.videos.find((video) => video.active);
    }

    /**
     * Verifica dentre os vídeos o ponto de continuar
     */
    public checkContinuePoint() {
        const notSeen = this.videos.find((video) => !video.progress);
        this.videos.map((video) => video.continuePoint = false);

        if (notSeen) {
            notSeen.continuePoint = true;
        }

    }
    // não remover, necessário para o funcionamento correto do @AutoUnsubscribe
    // tslint:disable-next-line:no-empty
    public ngOnDestroy() { }

    /**
     * Filtra dentre os vídeos os items que pertencem ao grupo da playlist
     * @param groupId id do grupo
     * @param videos videos a serem filtrados (objeto indexado)
     */
    private filterVideosByGroupId(groupId: string, videos: any) {
        const result = [];
        for (const key in videos) {
            if (videos[key].groupId === this.mediaGroupId) result.push(videos[key]);
        }
        return result;
    }
}
